import { render, staticRenderFns } from "./RadioComponent.vue?vue&type=template&id=6827bdf6&scoped=true&"
import script from "./RadioComponent.vue?vue&type=script&lang=js&"
export * from "./RadioComponent.vue?vue&type=script&lang=js&"
import style0 from "./RadioComponent.vue?vue&type=style&index=0&id=6827bdf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6827bdf6",
  null
  
)

export default component.exports